import { formatDateForMaistra, parseChildrenFromUrl } from '../utils-common'

class BookingParams {
  get urlString () {
    let urlParams = `date=${this.startDate.toISOString().split('T')[0]}&nights=${this.nights}&adults=${this.adults}`
    if (this.children.length) {
      urlParams += `&children=${this.children.reduce((str, age) => str + age.age + ',', '').slice(0, -1)}`
    }

    if (this.accessCode.trim() !== '') {
      urlParams += `&accessCode=${encodeURIComponent(this.accessCode)}`
    }

    if (this.ratePlanId.trim() !== '') {
      urlParams += `&ratePlanId=${encodeURIComponent(this.ratePlanId)}`
    }

    if (this.accountId.trim() !== '') {
      urlParams += `&accountId=${encodeURIComponent(this.accountId)}`
    }

    return urlParams
  }

  get endDate () {
    const endDate = new Date(this.startDate)
    endDate.setDate(endDate.getDate() + this.nights)
    return endDate
  }

  get displayDate () {
    return `${formatDateForMaistra(this.startDate)} - ${formatDateForMaistra(this.endDate)}`
  }

  constructor (props) {
    this.startDate = props?.startDate || new Date()
    this.nights = props?.nights || 1
    this.adults = props?.adults || 2
    this.children = props?.children || []
    this.accessCode = props?.accessCode || ''
    this.accountId = props?.accountId || ''
    this.ratePlanId = props?.ratePlanId || ''
  }

  displayGuests (t) {
    return `${t('bookingModal.adults')}: ${this.adults}, ${t('bookingModal.noChildren')}: ${this.children.length}`
  }

  updateFromUrl (urlParams) {
    this.startDate = urlParams.get('date') ? new Date(urlParams.get('date')) : this.startDate
    this.children = parseChildrenFromUrl(urlParams.get('children'))

    const intParams = ['nights', 'adults']
    const stringParams = ['accessCode', 'accountId', 'ratePlanId']
    intParams.forEach((slug) => {
      this[slug] = parseInt(urlParams.get(slug)) || this[slug]
    })
    stringParams.forEach((slug) => {
      this[slug] = decodeURIComponent(urlParams.get(slug) || '') || this[slug]
    })

    const saved = {};
    ['startDate', 'children'].concat(intParams, stringParams).forEach((slug) => {
      saved[slug] = this[slug]
    })
    return saved
  }

  update (params) {
    this.startDate = params.startDate
    this.nights = params.nights
    this.adults = params.adults
    this.children = params.children || []
    this.accessCode = params.accessCode || ''
    this.accountId = params.accountId || ''
    this.ratePlanId = params.ratePlanId || ''
  }
}

class BookingParamsWithFilters extends BookingParams {
  get urlString () {
    let params = super.urlString
    params += `&destination=${this.destination.slug}`
    if (this.property) {
      params += `&propertyId=${this.property.phobsId}`
    }
    return params
  }

  constructor (all) {
    super()
    this.destination = {}
    this.property = null
    this.all = all
  }
}

export { BookingParams, BookingParamsWithFilters }
